import { Resend } from 'resend'

import { APP_CONFIG } from '@/shared'

export const resend = new Resend(APP_CONFIG.RESEND_API_KEY as string)
